import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { MyCertificationProfileHeader } from '../../-components/CertificationProfileHeader';
import { CertificationKind } from '../../-constants';
import { useGetMyBaseCertificationHeader } from '../../-queries';
export const Route = createFileRoute('/_individual/individual/_profile/certifications/base-certifications/$id/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id
  } = useParams({
    from: '/_individual/individual/_profile/certifications/base-certifications/$id/_layout'
  });
  const {
    data
  } = useGetMyBaseCertificationHeader(id);
  return <VStack className="gap-0">
      <MyCertificationProfileHeader certificationId={id} certificationName={data.personBaseCertification.certificationName} certificationNumber={data.personBaseCertification.certificationNumber} certificationStatus={data.personBaseCertification.certificationStatus} certificationKind={CertificationKind.BASE} certificationHolder={{
      name: data.personBaseCertification.certificationHolder.name,
      avatarUrl: data.personBaseCertification.certificationHolder.avatarUrl ?? undefined
    }} />
      <Outlet />
    </VStack>;
}